import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'

import QuizForm from './QuizForm'
import QuizAttempt from './QuizAttempt'
import QuizResults from './QuizResults'
import QuizResultModal from './QuizResultModal'

@observer
class Quiz extends Component {
  render() {
    const { courseViewsStore, quizzesStore, defaultTheme, sellerFontsStore, payerStore } = this.props
    const { item: quiz } = quizzesStore
    const {
      showRetakeQuiz,
      showQuizResults,
      showQuizResultModal,
      viewConfig: { shouldCompleteQuiz },
    } = courseViewsStore

    const shouldRenderQuizForm = shouldCompleteQuiz || showRetakeQuiz

    return (
      <Fragment>
        {shouldRenderQuizForm ? (
          !!quiz?.quizQuestions?.length && (
            <QuizForm
              defaultTheme={defaultTheme}
              key={quiz?.id}
              courseViewsStore={courseViewsStore}
              quizzesStore={quizzesStore}
              sellerFontsStore={sellerFontsStore}
              payerStore={payerStore}
            />
          )
        ) : (
          <Fragment>
            {showQuizResults ? (
              <QuizResults
                defaultTheme={defaultTheme}
                courseViewsStore={courseViewsStore}
                quizzesStore={quizzesStore}
              />
            ) : (
              <QuizAttempt
                defaultTheme={defaultTheme}
                courseViewsStore={courseViewsStore}
                quizzesStore={quizzesStore}
              />
            )}
          </Fragment>
        )}
        {showQuizResultModal && (
          <QuizResultModal
            defaultTheme={defaultTheme}
            courseViewsStore={courseViewsStore}
            quizzesStore={quizzesStore}
          />
        )}
      </Fragment>
    )
  }
}

Quiz.displayName = 'Quiz'

export default Quiz
